import {
  Component,
  DestroyRef,
  effect,
  inject,
  viewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FullScreenMapProps } from '../interfaces';
import { DvDialogContent } from '@devinco/ui/dds';
import { MapComponent } from '../map.component';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'app-full-screen-map',
  templateUrl: './full-screen-map.component.html',
  styleUrls: ['./full-screen-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FullScreenMapComponent extends DvDialogContent<
  FullScreenMapProps,
  FullScreenMapComponent
> {
  readonly destroyRef = inject(DestroyRef);
  protected mapComponent = viewChild<MapComponent>('mapComponent');
  readonly fullScreenMapReady$ = new ReplaySubject<MapComponent>(1);
  constructor() {
    super();
    effect(() => {
      const instance = this.mapComponent();

      if (instance) {
        this.fullScreenMapReady$.next(instance);
      }
    });
  }

  close($event: boolean): void {
    if ($event) this.dialogRef.onClose();
  }
}
